module.exports = __webpack_public_path__ + "img/Bewegung_in_zwei_Richtungen.859d7a75.svg";